import styled from 'styled-components';
import { themePalette } from './../../utils/theme-palette';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 150px;
  padding: 0;
  border-radius: 6px;
  margin-right: 10px;
  height: 100%;
  box-shadow: 0px 2px 5px 1px rgb(0 0 0 / 13%);
  -webkit-box-shadow: 0px 2px 5px 1px rgb(0 0 0 / 13%);
  -moz-box-shadow: 0px 2px 5px 1px rgb(0 0 0 / 13%);
`;

export const ArticleImage = styled.div`
  width: 100%;
  height: 139px;
  max-height: 128px;
  img {
    object-fit: cover;
    object-position: center;
    width: 100%;
    height: 128px;
  }
`;

export const ArticleTitle = styled.span`
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 12px;
  color: #1f1f1f;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
  white-space: normal;
`;

export const CarouseLWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 15px;

  .alice-carousel__stage-item {
    margin-right: 12px;
    vertical-align: middle;
  }
  .alice-carousel__stage {
    padding: 2px 0;
  }
`;

export const Title = styled.div`
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  color: #1f1f1f;
`;

export const ArticleScore = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 2px;
  .score-title {
    font-size: 12px;
    text-transform: uppercase;
    line-height: 14px;
    font-weight: 600;
  }
  .score-body {
    font-size: 14px;
    text-transform: uppercase;
    line-height: 14px;
    font-weight: 600;
  }
  .green {
    color: ${themePalette.lighgreen};
  }
  .yellow {
    color: ${themePalette.yellow};
  }
  .red {
    color: ${themePalette.red};
  }
`;

export const BottomSection = styled.div`
  padding: 8px;
  display: flex;
  row-gap: 5px;
  height: 35px;
`;
